export default __webpack_public_path__ + "static/media/avatar_81.6cdff0e2.png";